import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { orderBy } from 'lodash';

/**
 * GetRiskRecordTimeline
 *
 * @TODO Needs description.
 *
 * @param payload
 * @returns {Promise<{timelines: {[p: string]: any}}>}
 * @constructor
 */
export const GetRiskRecordTimeline = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/risk-records/${thePayload?.eid}/timeline`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);
    const sortedTimelines = orderBy(Object.entries(remoteResponse?.data?.timelines), [0], ['desc']);

    return { timelines: Object.fromEntries(sortedTimelines) };
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/queries/GetRiskRecordTimeline.js -> GetRiskRecordTimeline()',
      false,
      error
    );

    throw error;
  }
};
